import { z } from 'zod';
/* ==========================================================================
 *  Referral share-to-earn wire contract (ADR-0024 §4 / T10.3)
 * ========================================================================== */
/** Response from GET /me/referral — the caller's invite code + share text. */
export const referralCodeResponseSchema = z.object({
    code: z.string(),
    /** Pre-rendered, ED-safe share text (locale-aware from the user's profile). */
    shareText: z.string(),
});
/** Body for POST /me/referral/apply — apply an inbound referral code. */
export const applyReferralCodeSchema = z.object({
    code: z.string().min(1).max(32),
});
/** Response from POST /me/referral/apply. */
export const applyReferralResponseSchema = z.object({
    /** True when the user already had a referral code applied — no new link was created. */
    alreadyApplied: z.boolean(),
});
//# sourceMappingURL=referral.js.map